import { useSelector } from 'react-redux';
import { accessibilitySelectors } from 'src/store';

export const useTheme = () => {
  const selectAccessibilityFontSize = useSelector(
    accessibilitySelectors.selectAccessibilityFontSize
  );

  return {
    colors: {
      dark: '#333',
      white: '#ffffff',
      white1: '#fafafa',
      white2: '#ffffff',
      white3: '#f0f0f0',
      white4: '#ededed',
      white5: '#e6e6e6',
      white6: '#f5f5f5',
      white7: '#f7f7f7',
      white8: '#e0e0e0',
      black: '#000000',
      lightBlue: '#C7E2FE',
      lightGreen: '#CBF2E0',
      veryLightBlue: '#e6f1ff',
      blue: '#0049be',
      primary: '#027AFF',
      brightBlue: '#007aff',
      navy: '#021d48',
      pinkishGrey: '#c1c1c1',
      warmGrey: '#808080',
      warmGrey2: '#727272',
      coolGrey: '#9a9da6',
      commentGrey: '#7687A3',
      warmGreyThree: '#999999',
      cloudyBlue: '#cacdd9',
      border: '#cacdd9',
      steel: '#82858c',
      silver: '#c8c9ce',
      duskBlue: '#324da9',
      paleRed: '#d84848',
      lightBlueGrey: '#d5d9e6',
      paleSkyBlue: '#c1e4fe',
      greyish: '#b1b1b1',
      shadowsBlack20: '#00000020',
      red: '#f44336',
      pinkishGreyTwo: '#bfbfbf',
      turkiz: '#0E416D',
      lightBrown: '#FFF6E7',
      newBlue: '#0F2951',
      appGrey: '#CFD3DD',
      iceBlue: '#EBF6FF',
      lightGray: '#e1e1e1',
      mintGreen: '#E1FCE7',
      slateGray: '#353b48',
      silverGray: '#C5C5C5'
    },
    spacing: {
      tiny: 5,
      small: 10,
      medium: 15,
      big: 30,
      large: 35,
      xLarge: 45,
      xxLarge: 50,
      xxxLarge: 60,
      xxxLarge200: 200
    },
    fonts: {
      fontSizes: {
        fontSize12: 12 * selectAccessibilityFontSize,
        fontSize13: 13 * selectAccessibilityFontSize,
        fontSize14: 14 * selectAccessibilityFontSize,
        fontSize15: 15 * selectAccessibilityFontSize,
        fontSize16: 16 * selectAccessibilityFontSize,
        fontSize17: 17 * selectAccessibilityFontSize,
        fontSize18: 18 * selectAccessibilityFontSize,
        fontSize19: 19 * selectAccessibilityFontSize,
        fontSize20: 20 * selectAccessibilityFontSize,
        fontSize21: 21 * selectAccessibilityFontSize,
        fontSize22: 22 * selectAccessibilityFontSize,
        fontSize23: 23 * selectAccessibilityFontSize,
        fontSize24: 24 * selectAccessibilityFontSize,
        fontSize25: 25 * selectAccessibilityFontSize,
        fontSize26: 26 * selectAccessibilityFontSize,
        fontSize27: 27 * selectAccessibilityFontSize,
        fontSize28: 28 * selectAccessibilityFontSize
      },
      classNames: {
        pageTitle: 'font-pageTitle',
        button: 'font-button',
        inputLabel: 'font-inputLabel',
        subPageTitle: 'sub-page-title',
        subPageTitleWhite: 'subPageTitleWhite',
        subPageTitleWidth: 'sub-page-title-width',
        comment: 'comment',
        cardTitle: 'card-title',
        cardSubtitle: 'card-subtitle',
        mainPageTitle: 'main-page-title',
        mainPageUserName: 'main-page-user-name',
        mobilePageTitle: 'mobile-page-title',
        mobileSubPageTitle: 'mobile-sub-page-title'
      }
    },
    sizes: {
      menuItemHeight: 60,
      inputBorderRadius: 6,
      dropDownMenuBorderRadius: 8,
      dropDownMenuItemHeight: 42,
      sideDocWidth: 390
    },
    breakpoints: {
      xs: 480, // Extra small screen / phone
      sm: 576, // Small screen / tablet
      md: 768, // Medium screen / desktop
      lg: 992, // Large screen / wide desktop
      xl: 1200, // Extra large screen / full hd
      xxl: 1600 // Extra extra large screen / large desktop
    },
    borderRadius: {
      regular: 6
    }
  };
};
